import { Mode, state } from "scripts/app";

export class ResetControls {
    btn: HTMLButtonElement;
        
        constructor(){
            const resetBtn = document.getElementById('resetBtn');
            if(!(resetBtn instanceof HTMLButtonElement)) {throw new Error("Ошибка! Кнопка сброса маркера не найдена")};
    
            this.btn = resetBtn;
            this.addEventListener();
        }

        /**
         * Блокируем кнопку сброса датчика
         */
        public setDisable() {
            this.btn.disabled = true;
        }
        public setEnable() {
            this.btn.disabled = false;
        }
    
        private addEventListener(){
            this.btn.addEventListener('click', () => this.resetSector());
        }
    
        private resetSector(){
            
            // Если датчик уже существует - сохраняем
            if(state.detector?.id != 'temp'){
                state.resetDetector = state.detector?.clone() ?? null;
            }

            state.detector?.reset();
            state.mode = Mode.waitForPoint;
        }
}